// Buffer global (ring) pentru erorile/avertismentele din consolă și erorile
// runtime necprinse — folosit de „Raportează o problemă" ca să atașeze automat
// ce s-a întâmplat în browser înainte de raport.

type LogEntry = { time: string; level: string; message: string };

const MAX = 100;
const buffer: LogEntry[] = [];

function stringifyArg(a: any): string {
  if (a instanceof Error) return `${a.name}: ${a.message}\n${a.stack || ''}`;
  if (typeof a === 'object' && a !== null) {
    try { return JSON.stringify(a); } catch { return String(a); }
  }
  return String(a);
}

function push(level: string, args: any[]) {
  try {
    const message = args.map(stringifyArg).join(' ');
    buffer.push({ time: new Date().toISOString(), level, message });
    if (buffer.length > MAX) buffer.shift();
  } catch { /* nu blocăm niciodată aplicația din cauza logării */ }
}

let installed = false;

export function installErrorCapture(): void {
  if (installed) return;
  installed = true;

  const origError = console.error.bind(console);
  const origWarn = console.warn.bind(console);

  console.error = (...args: any[]) => { push('error', args); origError(...args); };
  console.warn = (...args: any[]) => { push('warn', args); origWarn(...args); };

  window.addEventListener('error', (e: ErrorEvent) => {
    push('window.onerror', [e.message, `${e.filename}:${e.lineno}:${e.colno}`, e.error]);
  });
  window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
    push('unhandledrejection', [e.reason]);
  });
}

export function getErrorLogText(): string {
  return buffer.map(e => `[${e.time}] ${e.level}: ${e.message}`).join('\n');
}

// ---- Network (request-uri API) ------------------------------------------------
type NetEntry = { time: string; method: string; url: string; status: number | string; ms: number; detail?: string };
const NET_MAX = 60;
const netBuffer: NetEntry[] = [];

export function recordNetwork(e: NetEntry) {
  try {
    netBuffer.push(e);
    if (netBuffer.length > NET_MAX) netBuffer.shift();
  } catch { /* ignore */ }
}

export function getNetworkLogText(): string {
  return netBuffer
    .map(e => {
      const base = `[${e.time}] ${e.method} ${e.url} -> ${e.status} (${e.ms}ms)`;
      return e.detail ? `${base}\n    ${e.detail}` : base;
    })
    .join('\n');
}

export function getNetworkErrorCount(): number {
  return netBuffer.filter(e => typeof e.status === 'number' ? e.status >= 400 : true).length;
}

export function getErrorCount(): number {
  return buffer.length;
}

export function clearErrorLog(): void {
  buffer.length = 0;
}
